import { enhancedApi as webApi } from './web-api'

const enhancedApi = webApi.enhanceEndpoints({
    endpoints: {
        poolGetChargePoints: {
            providesTags: ['Pool'],
        },
        chargePointAddToPool: {
            invalidatesTags: ['ChargePoint', 'Pool'],
        },
        nfcTagConnectToUser: {
            invalidatesTags: ['NfcTag', 'Company'],
        },
        nfcTagDisconnectFromUser: {
            invalidatesTags: ['NfcTag', 'Company'],
        },
        partnerGetAlarmsByPartnerId: {
            providesTags: ['Alarm'],
        },
        partnerSetAcknowledged: {
            invalidatesTags: ['Alarm'],
        },
        partnerGetCompaniesByPartnerId: {
            providesTags: ['Company'],
        },
        companyAddMeasurementDeviceToCompany: {
            async onQueryStarted(_, { dispatch, queryFulfilled }) {
                await queryFulfilled
                dispatch(webApi.util.invalidateTags(['MeasurementDevices']))
            },
        },
        companyGetCompanyById: {
            providesTags: ['Company'],
        },
        partnerGetNfcTags: {
            providesTags: ['Partner'],
        },
        nfcTagCreate: {
            invalidatesTags: ['Company', 'NfcTag', 'Partner'],
        },
        nfcTagUpdate: {
            invalidatesTags: ['Company', 'NfcTag', 'Partner'],
        },
        nfcTagDelete: {
            invalidatesTags: ['Company', 'NfcTag', 'Partner'],
        },
        chargePointDeleteRejectedTag: {
            invalidatesTags: ['NfcTag'],
        },
        chargePointSetOwner: {
            invalidatesTags: ['User'],
        },
        chargingSessionGetChargingSessionsForCurrentUser: {
            providesTags: ['ChargingSession', 'ChargePoint', 'User'],
        },
    },
})
export { enhancedApi }
